import { render, staticRenderFns } from "./blueTitle.vue?vue&type=template&id=a5d18f2a&scoped=true"
import script from "./blueTitle.vue?vue&type=script&lang=js"
export * from "./blueTitle.vue?vue&type=script&lang=js"
import style0 from "./blueTitle.vue?vue&type=style&index=0&id=a5d18f2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d18f2a",
  null
  
)

export default component.exports